export enum ProcessType {
  input = 0,
  transform,
  map,
  output,
  done
}
